var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Liberia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M43.082,30H4.918c0.443,1.41,1.051,2.744,1.779,4h34.605C42.03,32.744,42.639,31.41,43.082,30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-0.675-0.036-1.342-0.101-2H23H4.101C4.036,22.658,4,23.325,4,24s0.036,1.342,0.101,2 h39.798C43.964,25.342,44,24.675,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M38.271,38H9.729c1.609,1.64,3.505,2.99,5.597,4h17.348C34.767,40.99,36.662,39.64,38.271,38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M23,18h20.082c-0.443-1.41-1.051-2.744-1.779-4H23V18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M23,10h15.271c-1.609-1.64-3.505-2.99-5.597-4H23V10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M32.674,6C30.047,4.732,27.112,4,24,4c-0.338,0-0.667,0.034-1,0.05V6H32.674z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M23,14h18.303c-0.845-1.458-1.859-2.805-3.031-4H23V14z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M23,22h20.899c-0.137-1.38-0.414-2.717-0.817-4H23V22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M43.899,26H4.101c0.137,1.38,0.414,2.717,0.817,4h38.163C43.484,28.717,43.762,27.38,43.899,26z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M41.302,34H6.698c0.845,1.458,1.859,2.805,3.031,4h28.543C39.444,36.805,40.458,35.458,41.302,34z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M15.326,42c2.627,1.268,5.562,2,8.674,2s6.047-0.732,8.674-2H15.326z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M23,18v-4v-4V6V4.05C13.089,4.542,5.072,12.223,4.101,22H23V18z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,9.488l1.18,3.75H20l-3.09,2.129L18.09,19L15,16.754L11.91,19l1.18-3.633L10,13.238h3.82L15,9.488 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Liberia);
export default __webpack_public_path__ + "static/media/icons8-liberia.d856fac2f0165fc753ebbafdaa247b33.svg";
export { ForwardRef as ReactComponent };